import httpStatus from "http-status";
import authHeader from "../helpers/auth-header";
import configuracio from "../configuracioEntorns";
import { guardarToken, eliminarToken } from "../utils/gestioWebToken";
import { MISSATGE_USUARI_NO_ACTIU } from "../constantsFormularis";
import {
  clearSessionForCurrentTab,
  markSessionForCurrentTab
} from "../utils/sessionTab";

const API_SERVER_URL = `${configuracio.api.URL}/fenocat/api`;
const OBSERVACIONS_URL = "/observacions";
const OBSERVADORS_URL = "/observadors";
const INDRETS_URL = "/indrets";
const INDIVIDUS_URL = "/individus";
const USUARIS_URL = "/usuaris";
const VISUALITZAR_URL = "/visualitzar";
const MUNICIPIS_URL = "/municipis";
const TOKEN_URL = "/token";
const COMENTARIS_URL = "/comentaris";

export const logout = () => {
  // remove user from local storage to log user out
  clearSessionForCurrentTab();
  eliminarToken();
};

const gestioErrorValidacio = response => {
  return response
    .json()
    .then(responseJson => {
      return Promise.reject(responseJson);
    })
    .catch(error => {
      return Promise.reject(error || "Error consultant el servidor.");
    });
};

const handleResponse = response => {
  if (!response.ok) {
    if (response.status === httpStatus.UNAUTHORIZED) {
      // auto logout if 401 response returned from api
      logout();
    }
    if (response.status === httpStatus.PARTIAL_CONTENT) {
      //FICHEROS
      return Promise.reject("Les fotos no s'han pogut inserir.");
    }
    if (response.status === httpStatus.BAD_REQUEST) {
      //BAD REQUEST
      return gestioErrorValidacio(response);
    }
    return response
      .json()
      .then(responseJson => {
        if (
          response.status === httpStatus.INTERNAL_SERVER_ERROR && //500
          responseJson.titol &&
          responseJson.message
        ) {
          return Promise.reject(responseJson);
        }
        const data = response && responseJson;
        const errorResp = (data && data.message) || response.statusText;

        return Promise.reject({ message: errorResp });
      })
      .catch(error => {
        if (error.message) {
          return Promise.reject(error);
        }
        return Promise.reject(error || "Error consultant el servidor.");
      });
  }

  return response
    .json()
    .then(responseJson => {
      return responseJson;
    })
    .catch(() => {
      return "error: resposta sense forma correcte.";
    });
};

const realitzarConsultaServidor = (
  url,
  parametresAEnviar = null,
  usuari = null
) => {
  if (usuari === null) {
    return fetch(url, parametresAEnviar)
      .then(handleResponse)
      .catch(error => {
        if (error.message && error.titol) {
          return Promise.reject(error);
        }
        if (!error.response) {
          // network error
          return Promise.reject("Error: Network Error");
        } else {
          return Promise.reject(error);
        }
      });
  }

  const idObservador = usuari.idObservador;
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(
    `${API_SERVER_URL}${USUARIS_URL}/observador/${idObservador}`
  );

  return fetch(urlObject.toString(), requestOptions)
    .then(respostaDadesUsuari => {
      if (!respostaDadesUsuari.ok) {
        return Promise.reject("Error GET USUARI");
      }
      return respostaDadesUsuari.json();
    })
    .then(dadesUsuari => {
      if (usuari && !dadesUsuari.actiu) {
        return Promise.reject(MISSATGE_USUARI_NO_ACTIU);
      }
      // Ahora realizamos la segunda llamada fetch usando los datos de la primera
      return fetch(url, parametresAEnviar); // Inicia la segunda llamada fetch
    })
    .then(handleResponse)
    .catch(error => {
      // Captura cualquier error de cualquiera de las peticiones
      return Promise.reject(error);
    });
};

export const fetchDadesIntroduccio = (dia, idObservador) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(`${API_SERVER_URL}${OBSERVACIONS_URL}/introduccio`);
  urlObject.searchParams.append("dia", dia.format("YYYY-MM-DD"));
  urlObject.searchParams.append("idObservador", idObservador);
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

export const fetchCanviObservacio = (idObservacio, idValor, usuari) => {
  const parametresAEnviar = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify({
      idObservacio,
      idValor
    })
  };
  const url = `${API_SERVER_URL}${OBSERVACIONS_URL}/introduccio`;
  return realitzarConsultaServidor(url, parametresAEnviar, usuari);
};

export const fetchCrearObservacio = (
  idIndividu,
  idFenofase,
  data,
  idValor,
  usuari
) => {
  const parametresAEnviar = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify({
      idIndividu,
      idFenofase,
      data,
      idValor
    })
  };

  const url = `${API_SERVER_URL}${OBSERVACIONS_URL}/introduccio`;
  return realitzarConsultaServidor(url, parametresAEnviar, usuari);
};

export const fetchEsborrarObservacio = (idObservacio, usuari) => {
  const parametresAEnviar = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    }
  };

  const url = `${API_SERVER_URL}${OBSERVACIONS_URL}/introduccio/${idObservacio}`;
  return realitzarConsultaServidor(url, parametresAEnviar, usuari);
};

export const fetchCanviComentari = (idComentari, text, usuari) => {
  const parametresAEnviar = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify({
      idComentari,
      text
    })
  };
  const url = `${API_SERVER_URL}${COMENTARIS_URL}`;
  return realitzarConsultaServidor(url, parametresAEnviar, usuari);
};

export const fetchCrearComentari = (idObservacio, text, usuari) => {
  const parametresAEnviar = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify({
      idObservacio,
      text
    })
  };

  const url = `${API_SERVER_URL}${COMENTARIS_URL}`;
  return realitzarConsultaServidor(url, parametresAEnviar, usuari);
};

export const fetchEsborrarComentari = (idComentari, usuari) => {
  const parametresAEnviar = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify({
      idComentari
    })
  };

  const url = `${API_SERVER_URL}${COMENTARIS_URL}/esborrar`;
  return realitzarConsultaServidor(url, parametresAEnviar, usuari);
};

export const fetchCrearFotoFenofaseIndividu = (dadesFoto, usuari) => {
  const parametresAEnviar = {
    method: "POST",
    headers: {
      ...authHeader()
    },
    body: dadesFoto
  };

  const url = `${API_SERVER_URL}${INDIVIDUS_URL}/introduccio/foto`;
  return realitzarConsultaServidor(url, parametresAEnviar, usuari);
};

export const fetchEliminarFotoFenofaseIndividu = (urlfoto, usuari) => {
  const parametresAEnviar = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify({ S3Key: urlfoto })
  };

  const url = `${API_SERVER_URL}${INDIVIDUS_URL}/introduccio/foto`;
  return realitzarConsultaServidor(url, parametresAEnviar, usuari);
};

export const fetchLogin = (usuari, contrasenya) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ nomUsuari: usuari, contrasenya })
  };

  const url = `${API_SERVER_URL}${USUARIS_URL}/login`;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(usuari => {
      // login successful if there's a jwt token in the response
      if (usuari.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        guardarToken(
          JSON.stringify({
            token: usuari.token
          })
        );
        markSessionForCurrentTab();
      }
      return usuari;
    });
};

/** Observadors **/
export const fetchObtenirObservadors = dia => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };

  const urlObject = new URL(`${API_SERVER_URL}${OBSERVADORS_URL}`);
  if (dia) {
    urlObject.searchParams.append("dia", dia.format("YYYY-MM-DD"));
  }
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

/** Observadors **/
export const fetchObtenirObservadorsLlistat = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(`${API_SERVER_URL}${OBSERVADORS_URL}/llistat/`);
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

/** Observador amb Dades Comarca Municipi, Usuari, Indrets **/
export const fetchObtenirDadesObservador = idObservador => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(
    `${API_SERVER_URL}${OBSERVADORS_URL}/llistat/${idObservador}`
  );
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

/** Observadors amb Especies**/
export const fetchObtenirObservadorsEspecies = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(`${API_SERVER_URL}${OBSERVADORS_URL}/especies/`);
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

export const fetchObtenirUsuari = idUsuari => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };

  const url = `${API_SERVER_URL}${USUARIS_URL}/${idUsuari}`;
  return realitzarConsultaServidor(url, requestOptions);
};

export const fetchObtenirDadesUsuariPerIdObservador = idObservador => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(
    `${API_SERVER_URL}${USUARIS_URL}/observador/${idObservador}`
  );
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

export const fetchObtenirObservador = idObservador => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };

  const url = `${API_SERVER_URL}${OBSERVADORS_URL}/${idObservador}`;
  return realitzarConsultaServidor(url, requestOptions);
};

export const fetchCanviarContrasenya = (
  idUsuari,
  contrasenyaActual,
  contrasenyaNova
) => {
  const parametresAEnviar = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify({ contrasenyaActual, contrasenyaNova })
  };

  const url = `${API_SERVER_URL}${USUARIS_URL}/${idUsuari}/contrasenya`;
  return realitzarConsultaServidor(url, parametresAEnviar);
};

export const fetchRestablirContrasenya = idObservador => {
  // TODO: revisa els parametres a enviar
  const parametresAEnviar = {
    method: "PUT",
    headers: authHeader()
  };
  const url = `${API_SERVER_URL}${USUARIS_URL}/${idObservador}/restablircontrasenya`;
  return realitzarConsultaServidor(url, parametresAEnviar);
};

export const fetchDonarAltaObservador = (idObservador, dataAlta, usuari) => {
  const dadesAEnviar = { dataAlta: dataAlta, usuari: usuari };

  // TODO: revisa els parametres a enviar
  const parametresAEnviar = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(dadesAEnviar)
  };

  const url = `${API_SERVER_URL}${OBSERVADORS_URL}/${idObservador}/alta`;
  return realitzarConsultaServidor(url, parametresAEnviar);
};

export const fetchDonarBaixaObservador = (
  idObservador,
  idHistoric,
  dataBaixa,
  motiuBaixa
) => {
  const dadesAEnviar = {
    dataBaixa: dataBaixa,
    motiuBaixa: motiuBaixa,
    idHistoric: idHistoric
  };

  const parametresAEnviar = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(dadesAEnviar)
  };

  const url = `${API_SERVER_URL}${OBSERVADORS_URL}/${idObservador}/baixa`;
  return realitzarConsultaServidor(url, parametresAEnviar);
};

/** Municipis **/
export const fetchObtenirMunicipis = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const url = `${API_SERVER_URL}${MUNICIPIS_URL}`;
  return realitzarConsultaServidor(url, requestOptions);
};

export const fetchObservacionsVisualitzar = (
  dataInici,
  dataFi,
  idEspecie,
  idFenofase
) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(
    `${API_SERVER_URL}${OBSERVACIONS_URL}/visualitzacio`
  );

  urlObject.searchParams.append("dataInici", dataInici.format("YYYY-MM-DD"));
  urlObject.searchParams.append("dataFi", dataFi.format("YYYY-MM-DD"));
  urlObject.searchParams.append("idEspecie", idEspecie);
  urlObject.searchParams.append("idFenofase", idFenofase);
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

export const fetchObtenirMunicipiComarca = codiINE => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const url = `${API_SERVER_URL}${OBSERVADORS_URL}/localitat/${codiINE}`;
  return realitzarConsultaServidor(url, requestOptions);
};

/**
 * Es fa la petició per a registrar-se a l'aplicació amb el token guardat al localStorage
 * @param {Object} token
 * @returns {*}
 */
export const fetchLoginAmbToken = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const url = `${API_SERVER_URL}${TOKEN_URL}`;
  return realitzarConsultaServidor(url, requestOptions);
};

export const fetchObservadorIntroduccioCrearObservador = dadesAmbFoto => {
  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader()
    },
    body: dadesAmbFoto
  };

  const url = `${API_SERVER_URL}${OBSERVADORS_URL}`;
  return realitzarConsultaServidor(url, requestOptions);
};

export const fetchObservadorIntroduccioEditarObservador = (
  idObservador,
  dadesAmbFoto
) => {
  const requestOptions = {
    method: "PUT",
    headers: {
      ...authHeader()
    },
    body: dadesAmbFoto
  };
  const url = `${API_SERVER_URL}${OBSERVADORS_URL}/${idObservador}`;

  return realitzarConsultaServidor(url, requestOptions);
};

/** Indrets **/
export const fetchObtenirIndrets = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = `${API_SERVER_URL}${INDRETS_URL}`;
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

export const fetchObtenirIndretsLlistat = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(`${API_SERVER_URL}${INDRETS_URL}/llistat/`);
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

/** Indret amb Dades de fotos **/
export const fetchObtenirDadesIndret = idIndret => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(
    `${API_SERVER_URL}${INDRETS_URL}/llistat/${idIndret}`
  );
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

export const fetchDonarBaixaIndret = (idIndret, dataBaixa, motiuBaixa) => {
  const dadesAEnviar = {
    dataBaixa: dataBaixa,
    motiuBaixa: motiuBaixa
  };

  const parametresAEnviar = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(dadesAEnviar)
  };

  const url = `${API_SERVER_URL}${INDRETS_URL}/baixa/${idIndret}`;
  return realitzarConsultaServidor(url, parametresAEnviar);
};

export const fetchIndretIntroduccioCrearIndret = dadesAmbFoto => {
  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader()
    },
    body: dadesAmbFoto
  };

  const url = `${API_SERVER_URL}${INDRETS_URL}`;
  return realitzarConsultaServidor(url, requestOptions);
};

export const fetchIndretIntroduccioEditarIndret = (idIndret, dadesAmbFotos) => {
  const requestOptions = {
    method: "PUT",
    headers: {
      ...authHeader()
    },
    body: dadesAmbFotos
  };
  const url = `${API_SERVER_URL}${INDRETS_URL}/${idIndret}`;

  return realitzarConsultaServidor(url, requestOptions);
};

/** visualitzar **/
export const fetchDadesVisualitzar = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(`${API_SERVER_URL}${VISUALITZAR_URL}`);
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

/** Individus **/
export const fetchObtenirIndividusLlistat = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(`${API_SERVER_URL}${INDIVIDUS_URL}/llistat/`);
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

export const fetchObtenirDadesIndividu = idIndividu => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(
    `${API_SERVER_URL}${INDIVIDUS_URL}/llistat/${idIndividu}`
  );
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

export const fetchObtenirDadesCreacioIndividu = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const urlObject = new URL(`${API_SERVER_URL}${INDIVIDUS_URL}/dadesCreacio/`);
  return realitzarConsultaServidor(urlObject.toString(), requestOptions);
};

export const fetchIndividuIntroduccioCrearIndividu = dadesAEnviar => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(dadesAEnviar)
  };

  const url = `${API_SERVER_URL}${INDIVIDUS_URL}`;
  return realitzarConsultaServidor(url, requestOptions);
};

export const fetchIndividuIntroduccioEditarIndividu = (
  idIndividu,
  dadesAEnviar
) => {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(dadesAEnviar)
  };
  const url = `${API_SERVER_URL}${INDIVIDUS_URL}/${idIndividu}`;

  return realitzarConsultaServidor(url, requestOptions);
};

export const fetchDonarBaixaIndretIndividu = (
  idIndividu,
  idIndret,
  dataBaixa,
  motiuBaixa
) => {
  const dadesAEnviar = {
    idIndret: idIndret,
    idIndividu: idIndividu,
    dataBaixa: dataBaixa,
    motiuBaixa: motiuBaixa
  };

  const parametresAEnviar = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader()
    },
    body: JSON.stringify(dadesAEnviar)
  };

  const url = `${API_SERVER_URL}${INDIVIDUS_URL}/baixa`;
  return realitzarConsultaServidor(url, parametresAEnviar);
};

export const fetchCrearFotosObservador = fotos => {
  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader()
    },
    body: fotos
  };

  const url = `${API_SERVER_URL}${OBSERVADORS_URL}/fotos/`;
  return realitzarConsultaServidor(url, requestOptions);
};

export const fetchResumObservador = (
  diaInici,
  diaFi,
  idObservador,
  observador
) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };

  const urlObject = new URL(`${API_SERVER_URL}${OBSERVACIONS_URL}/informe`);

  urlObject.searchParams.append("diaInici", diaInici.format("YYYY-MM-DD"));
  urlObject.searchParams.append("diaFi", diaFi.format("YYYY-MM-DD"));
  urlObject.searchParams.append("idObservador", parseInt(idObservador));
  urlObject.searchParams.append("observador", JSON.stringify(observador));
  return realitzarDescarregaServidor(
    urlObject.toString(),
    requestOptions,
    diaInici
  );
};

const realitzarDescarregaServidor = (url, parametresAEnviar = null, diaInici) =>
  fetch(url, parametresAEnviar)
    .then(resposta => {
      const contentType = resposta.headers.get("Content-Type") || "";
      if (resposta.ok) {
        const anyInforme = diaInici.year();
        resposta.blob().then(blob => {
          download(blob, `InformeAnual${anyInforme}.xlsx`);
        });

        if (contentType.includes("numDiesAmbDades=0")) {
          return {
            titol: "Avís descarrega informe",
            message: `No hi ha dades d'observacions a l'any ${anyInforme}`
          };
        }
      } else {
        if (contentType.includes("anyinforme=null")) {
          return {
            titol: "Error generant informe",
            message: "No s'ha trobat l'any de l'informe"
          };
        }
        return Promise.reject(resposta);
      }
    })
    .catch(error => {
      return Promise.reject(error);
    });

const download = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};
